import { graphql, useStaticQuery } from 'gatsby';
import get from 'lodash.get';

export interface OrganizationData {
  name: string;
  legalName: string;
  telephone: string;
  email: string;
}

const OrganizationQuery = (): OrganizationData => {
  const data = useStaticQuery(graphql`
    query {
      allSiteSettingEntityAdministration {
        edges {
          node {
            field_organization_name
            field_organization_legal_name
            field_organization_phone
            field_email_contact_form_1
          }
        }
      }
    }
  `);

  const node = get(data, 'allSiteSettingEntityAdministration.edges[0].node', {});

  return {
    name: get(node, 'field_organization_name') || 'iPOS',
    legalName: get(node, 'field_organization_legal_name') || '',
    telephone: get(node, 'field_organization_phone') || '',
    email: get(node, 'field_email_contact_form_1') || '',
  };
};

export default OrganizationQuery;
